// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading{
    position: fixed;
    z-index: 99999;
    height: 100%;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.2);
    display: none;
}
.spinner {
    margin: 15% 45%;
    width: 50px;
    height: 40px;
    text-align: center;
    font-size: 10px;
    position: absolute;
    z-index:99;
}
.spinner > div {
    background-color: var(--color-primary-orange);;
    height: 100%;
    width: 6px;
    display: inline-block;
    animation: sk-stretchdelay 1.2s infinite ease-in-out;
}
.spinner .rect2 {
    animation-delay: -1.1s;
}
.spinner .rect3 {
    animation-delay: -1.0s;
}
.spinner .rect4 {
    animation-delay: -0.9s;
}
.spinner .rect5 {
    animation-delay: -0.8s;
}
@keyframes sk-stretchdelay {
    0%, 40%, 100% { 
        transform: scaleY(0.4);
        -webkit-transform: scaleY(0.4);
    }  20% { 
        transform: scaleY(1.0);
        -webkit-transform: scaleY(1.0);
    }
}`, "",{"version":3,"sources":["webpack://./src/shared/components/Loader.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,cAAc;IACd,YAAY;IACZ,WAAW;IACX,0CAA0C;IAC1C,aAAa;AACjB;AACA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,6CAA6C;IAC7C,YAAY;IACZ,UAAU;IACV,qBAAqB;IAGrB,oDAAoD;AACxD;AACA;IAEI,sBAAsB;AAC1B;AACA;IAEI,sBAAsB;AAC1B;AACA;IAEI,sBAAsB;AAC1B;AACA;IAEI,sBAAsB;AAC1B;AAKA;IACI;QACI,sBAAsB;QACtB,8BAA8B;IAClC,GAAG;QACC,sBAAsB;QACtB,8BAA8B;IAClC;AACJ","sourcesContent":[".loading{\n    position: fixed;\n    z-index: 99999;\n    height: 100%;\n    width: 100%;\n    background-color: rgba(255, 255, 255, 0.2);\n    display: none;\n}\n.spinner {\n    margin: 15% 45%;\n    width: 50px;\n    height: 40px;\n    text-align: center;\n    font-size: 10px;\n    position: absolute;\n    z-index:99;\n}\n.spinner > div {\n    background-color: var(--color-primary-orange);;\n    height: 100%;\n    width: 6px;\n    display: inline-block;\n\n    -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;\n    animation: sk-stretchdelay 1.2s infinite ease-in-out;\n}\n.spinner .rect2 {\n    -webkit-animation-delay: -1.1s;\n    animation-delay: -1.1s;\n}\n.spinner .rect3 {\n    -webkit-animation-delay: -1.0s;\n    animation-delay: -1.0s;\n}\n.spinner .rect4 {\n    -webkit-animation-delay: -0.9s;\n    animation-delay: -0.9s;\n}\n.spinner .rect5 {\n    -webkit-animation-delay: -0.8s;\n    animation-delay: -0.8s;\n}\n@-webkit-keyframes sk-stretchdelay {\n    0%, 40%, 100% { -webkit-transform: scaleY(0.4) }  \n    20% { -webkit-transform: scaleY(1.0) }\n}\n@keyframes sk-stretchdelay {\n    0%, 40%, 100% { \n        transform: scaleY(0.4);\n        -webkit-transform: scaleY(0.4);\n    }  20% { \n        transform: scaleY(1.0);\n        -webkit-transform: scaleY(1.0);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
